import { postApiFinanceBalance } from "@/redux/reducers/authSlice";
import { AppDispatch, RootState } from "@/redux/store";
import { pxToRem } from "@/util/common";
import { Image } from "antd-mobile";
import { useState } from "react";
import { createUseStyles } from "react-jss";
import { useDispatch, useSelector } from "react-redux";

const Navigation: React.FC<{
	onWalletClick?: () => void;
	onMoreClick?: () => void;
}> = (props) => {
	const { balance } = useSelector((state: RootState) => state.auth);
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();

	const [isRefresh, setIsRefresh] = useState(false);
	const postApiFinanceBalanceHandle = async () => {
		setIsRefresh(true);
		await dispatch(postApiFinanceBalance({}));
		setTimeout(() => {
			setIsRefresh(false);
		}, 500);
	};

	return (
		<header className={classes.wrap}>
			<div className={classes.moreWrap} onClick={props.onMoreClick}>
				<Image
					src={require("@/assets/images/icons/more.png")}
					width={pxToRem(18)}
					height={pxToRem(17)}
				/>
			</div>
			<div className={classes.app}>
				<Image
					src={require("@/assets/images/icons/logo_small.png")}
					width={pxToRem(32)}
				/>
				<h3>
					COIN
					<br />
					GAMING
				</h3>
			</div>
			<div className={classes.balanceWrap} onClick={props.onWalletClick}>
				<Image
					src={require("@/assets/images/icons/coin.png")}
					width={pxToRem(23)}
				/>
				<strong>{balance?.[1] ?? 0}</strong>
				<div
					style={{ padding: "3px" }}
					onClick={(event) => {
						event.preventDefault();
						event.stopPropagation();
						postApiFinanceBalanceHandle();
					}}
				>
					<Image
						src={require("@/assets/images/icons/refresh_white.png")}
						width={pxToRem(13)}
						height={pxToRem(13)}
						style={{ marginLeft: pxToRem(5) }}
						className={isRefresh ? "refresh" : ""}
					/>
				</div>
				<Image
					src={require("@/assets/images/icons/wallet.png")}
					width={pxToRem(22)}
					height={pxToRem(18)}
					style={{ marginLeft: pxToRem(5) }}
				/>
			</div>
		</header>
	);
};

export default Navigation;

const useStyles = createUseStyles({
	wrap: {
		padding: pxToRem(17),
		paddingLeft: pxToRem(20),
		display: "flex",
		alignItems: "center",
		color: "#fff",
	},
	moreWrap: {
		border: "1px solid #2F3A62",
		borderRadius: "100%",
		width: pxToRem(40),
		height: pxToRem(40),
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	app: {
		marginLeft: pxToRem(15),
		flex: 1,
		display: "flex",
		alignItems: "center",
		"& > h3": {
			marginLeft: pxToRem(5),
			fontSize: pxToRem(15),
			fontWeight: 700,
			lineHeight: pxToRem(18),
		},
	},
	balanceWrap: {
		height: pxToRem(40),
		borderRadius: pxToRem(20),
		border: "1px solid #2F3A62",
		paddingLeft: pxToRem(12),
		paddingRight: pxToRem(10),
		backgroundColor: "1E212B",
		display: "flex",
		alignItems: "center",

		"& > strong": {
			marginLeft: pxToRem(6),
			fontSize: pxToRem(14),
			fontWeight: 600,
			textAlign: "center",
			minWidth: pxToRem(20),
		},
	},
});
